import { render, staticRenderFns } from "./SlideGroup.vue?vue&type=template&id=df370720&scoped=true&"
import script from "./SlideGroup.vue?vue&type=script&lang=js&"
export * from "./SlideGroup.vue?vue&type=script&lang=js&"
import style0 from "./SlideGroup.vue?vue&type=style&index=0&id=df370720&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df370720",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBtn,VCard,VCol,VContainer,VIcon,VRow,VSlideGroup,VSlideItem})
